export default "__VITE_ASSET__D2QD4v8E__"